import { useEffect, useState } from "react";
import Hero from "../../components/Hero/Hero";
import Navbar from "../../components/Navbar/Navbar";
import MetaTagsSeo from "../../components/Shared/MetaTagsSeo";
import LoadingPage from "../Loader/LoadingPage";
function Home() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const startTime = Date.now();

    const handleLoad = () => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(800 - elapsed, 0);

      setTimeout(() => {
        setLoading(false);
      }, remaining);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);
  return (
    <>
      <MetaTagsSeo
        title="FROI – Future Ready Organization Institute"
        description="Future Ready Organization Institute (FROI) develops future readiness standards, models, research, and accreditation frameworks for government human capital practices."
        keywords={[
          "FUTURE READY ORGANIZATION INSTITUTE",
          "Future Ready",
          "Future Ready Organization",
          "Future Ready Government",
          "Future Readiness Standards for Government Human Capital Practices",
          "Human Capital Future Readiness",
          "Future Readiness Index",
          "Government Human Capital Future Readiness Accreditation",
          "Future Readiness Accreditation",
          "Government Human Capital Future Readiness Index",
          "Future Readiness Research & Studies",
          "FROI's Future Ready Government Human Capital Model",
        ].join(", ")}
        OGDescription="Future Ready Organization Institute (FROI) develops future readiness standards, models, research, and accreditation frameworks for government human capital practices."
        url="https://www.froiglobal.org/"
      />
      {/* <Navbar /> */}
      <Hero />
      {loading && <LoadingPage />}
    </>
  );
}

export default Home;
